import { Directive } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { Observable, tap } from 'rxjs'

import {
  ActiveSorting,
  TableBaseAbstract,
} from '../../abstracts/table-base.abstract'
import { Branch, BranchStatus } from '../../models/branch.model'
import { Expression } from '../../repositories/base.repository'
import { BranchRepository } from '../../repositories/branch/branch.repository'
import { ValueFilterOption } from '../value-filter/value-filter.component'
import { TableData } from './branch-base.component'

export type StatusOption = { label: string; value: 'all' | BranchStatus }

@Directive()
export abstract class BranchBaseAbstract extends TableBaseAbstract {
  public typeToken!: { index: number; item: string; currentRow: TableData }

  public valueFilterOptions: ValueFilterOption[] = []

  public tableData: TableData[] = []
  public activeState: string = 'all'

  public override activeSorting: ActiveSorting = [
    {
      key: 'createdAt',
      value: 'descend',
    },
  ]

  protected defaultFilter!: Expression

  protected constructor(
    protected readonly branchRepository: BranchRepository,
    protected readonly translateService: TranslateService
  ) {
    super()
  }

  public onStateFilterChange(state: string): void {
    this.activeState = state
    this.pageIndex = 1
    this.updateTableData()
  }

  public onSearchFilterChange(sword: string): void {
    this.sword = sword
    this.updateTableData()
  }

  protected getFilter(): Expression<Branch>[] {
    const filter: Expression<Branch>[] = []

    filter.push(this.defaultFilter)

    if (this.sword) {
      filter.push(
        this.branchRepository.getSearchQuery(this.sword, [
          'note',
          'createdBy',
          'fundingCode',
          'mevId',
          'reason',
          'source',
        ])
      )
    }

    if (this.activeState !== 'all') {
      filter.push({
        name: 'state',
        val: this.activeState,
        op: 'eq',
      })
    }

    return filter
  }

  protected translateOptionsKeys(untranslatedOptions: StatusOption[]): void {
    this.translateService
      .get(untranslatedOptions.map((key) => key.label))
      .subscribe((keys) => {
        this.valueFilterOptions = untranslatedOptions.map((option) => ({
          label: keys[option.label],
          value: option.value,
        }))
      })
  }

  protected fetchTableData(): Observable<unknown> {
    return this.branchRepository
      .list({
        limit: this.pageSize,
        page: this.pageIndex,
        filter: this.getFilter(),
        sorting: this.getSorting(),
      })
      .pipe(
        tap((response) => {
          this.total = response.meta.totalCount
          this.tableData = response.data.map((res) => ({
            ...res.attributes,
            id: res.id,
          }))
          this.isLoading = false
        })
      )
  }
}
